var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import Icon from "../../../components/Library/Icon/Icon";
import SubscribeButton from "../../../components/Library/SubscribeButton";

import styles from "./Subscribe.css";

var Subscribe = function (_Component) {
  _inherits(Subscribe, _Component);

  function Subscribe() {
    _classCallCheck(this, Subscribe);

    return _possibleConstructorReturn(this, (Subscribe.__proto__ || Object.getPrototypeOf(Subscribe)).apply(this, arguments));
  }

  _createClass(Subscribe, [{
    key: "render",
    value: function render() {
      var subscription = this.props.subscription;

      if (!subscription) return null;

      return React.createElement(
        "div",
        null,
        React.createElement(
          "div",
          { className: styles.content },
          React.createElement(
            "div",
            { className: styles.text },
            React.createElement(
              "strong",
              null,
              subscription.name
            ),
            React.createElement(
              "div",
              null,
              subscription.description
            )
          )
        ),
        subscription.isSubscribed ? React.createElement(
          SubscribeButton,
          { className: styles.subscribed, disabled: true },
          React.createElement(Icon, { name: "check/rounded", className: styles.check }),
          "Subscribed"
        ) : React.createElement(
          SubscribeButton,
          { className: styles.subscribe, onClickSubscribe: this.props.onClickSubscribe },
          "Subscribe"
        )
      );
    }
  }]);

  return Subscribe;
}(Component);

export default Subscribe;


// WEBPACK FOOTER //
// ./src/author/components/Subscribe/Subscribe.js